import React, { useState, useEffect } from "react";
import { Table, Button, Card, Row, Col, Modal, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Form, InputGroup } from "react-bootstrap";
import { LiaAngleDownSolid, LiaAngleUpSolid } from "react-icons/lia";
import Celebration from "../assets/images/icons/Celebration.png";
import { Tabs, Tab } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';
import { userService } from '../services/userService';
import { urlService } from '../services/urlService';
import { accountService } from '../services/accountService';
import BulkUpload from "./BulkUpload";
import urlShortIcon from "../assets/images/icons/url-short-icon.png"
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import { FcClearFilters } from "react-icons/fc";
import urlTrackingIcon from "../assets/images/icons/url-link.svg";
import individualTrackingIcon from "../assets/images/mouse-clicker.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { MdOutlineDownloadForOffline } from "react-icons/md";
import { useLocation } from 'react-router-dom';
import { formatDateForAPI } from '../utils/dateUtils';

const SingleUrl = () => {

  const [domains, setDomains] = useState([]);

  const [formData, setFormData] = useState({
    campaignName: "",
    longUrl: "",
    locale: "",
    language: "",
    senderId: "",
    indivId: "",
    mobileNo: "",
    urlTracking: false,
    individualTracking: false,
    domain: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const [username, setUsername] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [senderIds, setSenderIds] = useState([]);

  const [locales, setLocales] = useState([]);

  const [initialUrlTracking, setInitialUrlTracking] = useState(false);
  const [initialIndividualTracking, setInitialIndividualTracking] = useState(false);

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const decoded = jwtDecode(token);
          setUsername(decoded.sub);

          // Define the config object for API calls
          const config = {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          };

          const userData = await userService.getUserByUsername(decoded.sub);
          setCompanyId(userData.accountId);

          const accountConfig = await accountService.getAccountConfigById(userData.accountId);
          
       
          setSenderIds(accountConfig.senderIds || []);

          // Fetch detailed domain objects to include verification status
          try {
            const domainObjs = await accountService.getDomainsByAccount(userData.accountId);
            setDomains(Array.isArray(domainObjs) ? domainObjs : []);
          } catch (e) {
            // Fallback to basic mapping from accountConfig if detailed fetch fails
            setDomains(accountConfig.domains?.map((domain, index) => ({
              id: index,
              domain: domain,
              accountId: userData.accountId,
              defaultDomain: domain === accountConfig.defaultDomain,
              assigned: true
            })) || []);
          }
          
          // Set the initial values
          setInitialUrlTracking(accountConfig.urlTracking);
          setInitialIndividualTracking(accountConfig.individualTracking);
          
          // Set the initial checkbox states
          setShowForm(accountConfig.urlTracking);
          setShowIndividualForm(accountConfig.individualTracking);
          
          // Set the initial form data
          setFormData(prev => ({
            ...prev,
            urlTracking: accountConfig.urlTracking,
            individualTracking: accountConfig.individualTracking,
            domain: accountConfig.defaultDomain || ""
          }));
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error('Failed to fetch account configuration. Please try again.');
      }
    };

    getUserDetails();
  }, []);



  const [shortUrl, setShortUrl] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const data = await urlService.shortenUrl({
        ...formData,
        language: formData.language
      });
      setShortUrl(data.shortUrl);
      handleShow();
      
      const fromDateStr = formatDateForAPI(startDate);
      const toDateStr = formatDateForAPI(endDate);
      const historyResponse = await urlService.getUrlMappingsByAccount(companyId, page, size, fromDateStr, toDateStr);
      
      if (historyResponse) {
        setHistoryData(Array.isArray(historyResponse.content) ? historyResponse.content : []);
        setFilteredHistoryData(Array.isArray(historyResponse.content) ? historyResponse.content : []);
        setTotalPages(historyResponse.totalPages);
        setTotalElements(historyResponse.totalRecords);
      }
      
      toast.success('URL shortened successfully!');
    } catch (error) {
      console.error('Error shortening URL:', error);
      toast.error('Failed to shorten URL. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  // Clear all form fields when the user clicks Cancel
  const handleCancel = () => {
    const defaultDomain = (domains.find((d) => d.defaultDomain)?.domain) || "";
    setFormData({
      campaignName: "",
      longUrl: "",
      locale: "",
      language: "",
      senderId: "",
      indivId: "",
      mobileNo: "",
      urlTracking: false,
      individualTracking: false,
      domain: defaultDomain,
    });
    setShowForm(false);
    setShowIndividualForm(false);
  };


  const [showTable, setShowTable] = useState(true);
  const [showForm, setShowForm] = useState(false);


  const toggleTable = () => {
    setShowTable(!showTable);
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const [historyData, setHistoryData] = useState([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const [showDownloadPopup, setShowDownloadPopup] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredHistoryData, setFilteredHistoryData] = useState([]);

  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    return lastMonth;
  });

  const [endDate, setEndDate] = useState(() => new Date());
  const [searchTimeout, setSearchTimeout] = useState(null);

  const handleDateChange = (date, isStartDate) => {
    if (isStartDate) {
      setStartDate(date);
      if (endDate && date > endDate) {
        setEndDate(date);
      }
    } else {
      setEndDate(date);
      if (startDate && date < startDate) {
        setStartDate(date);
      }
    }
  };

  const handleSearch = async (value) => {
    setSearchTerm(value);
    setIsSearching(true);
    
    try {
      const fromDateStr = formatDateForAPI(startDate);
      const toDateStr = formatDateForAPI(endDate);

      const response = await urlService.searchUrlMappings(companyId, value, page, size, fromDateStr, toDateStr);

      if (response) {
        setFilteredHistoryData(Array.isArray(response.content) ? response.content : []);
        setTotalPages(response.totalPages);
        setTotalElements(response.totalRecords);
      }
    } catch (error) {
      console.error('Error searching history:', error);
      toast.error('Search failed. Please try again.');
    } finally {
      setIsSearching(false);
      setCurrentDisplayPage(0);
    }
  };

  const debouncedSearch = (value) => {
    setSearchTerm(value);
    
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    if (!value.trim()) {
      setPage(0);
    }

    const timeoutId = setTimeout(() => {
      handleSearch(value);
    }, 500);

    setSearchTimeout(timeoutId);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsHistoryLoading(true);
      try {
        // Use proper date formatting without timezone issues
        const fromDateStr = formatDateForAPI(startDate);
        const toDateStr = formatDateForAPI(endDate);

        const historyResponse = await urlService.getUrlMappingsByAccount(companyId, page, size, fromDateStr, toDateStr);

        if (historyResponse) {
          setHistoryData(Array.isArray(historyResponse.content) ? historyResponse.content : []);
          setFilteredHistoryData(Array.isArray(historyResponse.content) ? historyResponse.content : []);
          setTotalPages(historyResponse.totalPages);
          setTotalElements(historyResponse.totalRecords);
        }
      } catch (error) {
        console.error('Error fetching history:', error);
        toast.error('Failed to load history. Please refresh the page.');
      } finally {
        setIsHistoryLoading(false);
      }
    };

    if (companyId) {
      fetchData();
    }
  }, [companyId, page, size, startDate, endDate]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    const token = localStorage.getItem('token');
    if (token) {
      const decoded = jwtDecode(token);
      userService.getUserByUsername(decoded.sub).then(userData => {
        return accountService.getAccountConfigById(userData.accountId);
      }).then(accountConfig => {
        setShowForm(accountConfig.urlTracking);
        setShowIndividualForm(accountConfig.individualTracking);
        setFormData(prev => ({
          ...prev,
          campaignName: "",
          longUrl: "",
          locale: "",
          language: "",
          senderId: "",
          indivId: "",
          mobileNo: "",
          urlTracking: accountConfig.urlTracking,
          individualTracking: accountConfig.individualTracking,
          domain: accountConfig.defaultDomain || ""
        }));
      }).catch(error => {
        console.error('Error resetting form:', error);
        toast.error('Error resetting form. Please try again.');
      });
    }
  };

  const longUrl =
    "https://www.comsensetechnologies.com/wp-content/uploads/2023/08/IntellSense_Adidas.pdf";

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(shortUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [companyUrlHistory, setCompanyUrlHistory] = useState([]);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const decodedToken = jwtDecode(token);
          setIsSuperAdmin(decodedToken.roles.includes('SUPERADMIN'));
        }
      } catch (err) {
        console.error('Error decoding token:', err);
        setIsSuperAdmin(false);
      }
    };

    const fetchCompanies = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const decoded = jwtDecode(token);
          const userData = await userService.getUserByUsername(decoded.sub);
          const response = await accountService.getAccountConfigById(userData.accountId);
          if (response) {
            setCompanies([response]);
          }
        }
      } catch (err) {
        console.error("Failed to fetch companies:", err);
      }
    };

    checkUserRole();
    fetchCompanies();
  }, []);

  const [companyHistoryPage, setCompanyHistoryPage] = useState(0);
  const [companyHistorySize] = useState(10);
  const [companyHistoryTotalPages, setCompanyHistoryTotalPages] = useState(0);
  const [companyHistoryTotalElements, setCompanyHistoryTotalElements] = useState(0);

  const fetchCompanyUrlHistory = async (accountId, pageNumber = 0) => {
    try {
      const response = await urlService.getUrlMappingsByAccount(accountId, pageNumber, companyHistorySize);
      
      if (response) {
        setCompanyUrlHistory(response.content);
        setCompanyHistoryTotalPages(response.totalPages);
        setCompanyHistoryTotalElements(response.totalRecords);
        setSelectedCompanyId(accountId);
        setCompanyHistoryPage(pageNumber);
      }
    } catch (err) {
      console.error("Failed to fetch company URL history:", err);
    }
  };

  const handleCompanyHistoryPageChange = (newPage) => {
    fetchCompanyUrlHistory(selectedCompanyId, newPage);
  };

  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);

  const handleDownloadReport = async () => {
    try {
      setIsCSVDownloading(true);
      setIsDownloading(true);
      setDownloadProgress(0);
      const token = localStorage.getItem('token');
      
      const fromDate = startDate ? startDate.toISOString().split('T')[0] : '';
      const toDate = endDate ? endDate.toISOString().split('T')[0] : '';
      
      const response = await urlService.exportUrlMappings(
        companyId,
        searchTerm,
        fromDate,
        toDate,
        (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setDownloadProgress(percentCompleted || 0);
        }
      );

      const blob = new Blob([response], { type: 'text/csv' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `url-mappings-${fromDate}-to-${toDate}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      
      toast.success('Report downloaded successfully!');
      setShowDownloadPopup(false);
    } catch (error) {
      console.error('Error downloading report:', error);
      toast.error('Failed to download report. Please try again.');
    } finally {
      setIsCSVDownloading(false);
      setIsDownloading(false);
      setDownloadProgress(0);
    }
  };

  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  const handleCloseDownloadModal = () => {
    if (isDownloading && downloadProgress < 100) {
      setShowCancelConfirm(true);
    } else {
      setShowDownloadPopup(false);
      setDownloadProgress(0);
    }
  };

  const [isCSVDownloading, setIsCSVDownloading] = useState(false);

  const [showIndividualForm, setShowIndividualForm] = useState(false);

  const [displaySize] = useState(10);
  const [currentDisplayPage, setCurrentDisplayPage] = useState(0);

  useEffect(() => {
    // Show "Download Full Report" option only when total records exceed 100
    if (totalElements > 100 && !searchTerm && !startDate && !endDate) {
      setShowDownloadPopup(true);
    } else {
      setShowDownloadPopup(false);
    }
  }, [totalElements, searchTerm, startDate, endDate]);

  const location = useLocation();
  const [activeTab, setActiveTab] = useState('single');

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam === 'bulk') {
      setActiveTab('bulk');
    } else {
      setActiveTab('single');
    }
  }, [location.search]);

  useEffect(() => {
    const fetchLocales = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await userService.getLocales();
        setLocales(response);
      } catch (error) {
        console.error('Error fetching locales:', error);
        toast.error('Failed to fetch locales');
      }
    };

    if (activeTab === 'single') {
      fetchLocales();
    }
  }, [activeTab]);

  return (
    <>
      {/* <div className="breadcrub-container">
        <Breadcrumb className="breadcrumb bg-white">
          <Breadcrumb.Item href="#">
          <Image width="18" src={urlShortIcon}/>
          </Breadcrumb.Item>
          <Breadcrumb.Item active className="text-0C1116 fs-14 fw-600 poppins">
            URL Shortening
          </Breadcrumb.Item>
        </Breadcrumb>
      </div> */}

              <Card className="card-nostyle border-0 shadow-none" style={{ marginTop: "70px" }}>
                <Card.Body className="ps-0 pe-0">
                  <div
                    className="d-flex justify-content-between ps-4 pe-4 align-items-center"
                    style={{ borderBottom: "1px solid #EAECF0" }}
                  >
                    <h4 className="mb-0 bg-white br-radius-12 rounded-bottom-0 pb-3 fs-20 poppins fw-600">
                      <Image src={urlShortIcon} className="me-1" width="20" />{" "}
                      URL Shortening
                    </h4>
                  </div>
                  </Card.Body>
                  </Card>
      
      

      <div className="main-container pt-1">
        <Row>
          <Col lg={12}>
            <Card className="br-radius-12">
              <Card.Body>
                {!isSuperAdmin && (
                  <Tabs
                    activeKey={activeTab}
                    onSelect={(tab) => setActiveTab(tab)}
                    id="url-shortening-tabs"
                    className="mb-3 cust-tab"
                    justify
                  >
                    <Tab eventKey="single" title="Single URL">
                      <div className="main-container p-0">
                        <Row className="">
                          <Col lg={12}>
                            <Card className="br-radius-0 border-0 shadow-none">
                              <Card.Body className="p-1">
                                <Form onSubmit={handleSubmit} className="">
                                  <Row>
                                    <Col md={6}>
                                      <Form.Group className="mb-3">
                                        <Form.Label className="fs-12">Sender ID</Form.Label>
                                        <Form.Select
                                          name="senderId"
                                          value={formData.senderId}
                                          onChange={handleInputChange}
                                          className="placeholder-text"
                                        >
                                          <option value="">Select Sender ID</option>
                                          {senderIds.map((senderId, index) => (
                                            <option key={index} value={senderId}>
                                              {senderId}
                                            </option>
                                          ))}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                      <Form.Group>
                                        <Form.Label className="fs-12">Domain</Form.Label>
                                        <Form.Select
                                          name="domain"
                                          value={formData.domain}
                                          onChange={handleInputChange}
                                          className="placeholder-text"
                                        >
                                          <option value="">Select Domain</option>
                                          {domains.map((domain, index) => (
                                            <option 
                                              key={index} 
                                              value={domain.domain}
                                              className={domain.defaultDomain ? 'fw-bold' : ''}
                                            >
                                              {domain.domain} {domain.defaultDomain ? '(Default)' : ''} {`- ${domain.assigned ? 'Verified' : 'Not Verified'}`}
                                            </option>
                                          ))}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col>
                                  </Row>

                                  <Form.Group className="mb-3">
                                    <Form.Label className="fs-12">Long URL</Form.Label>
                                    <Form.Control
                                      type="url"
                                      name="longUrl"
                                      value={formData.longUrl}
                                      onChange={handleInputChange}
                                      placeholder="eg. https://my-long-url.com"
                                      required
                                    />
                                    <Form.Text className="text-242D35 fs-12">
                                      <strong className="GeneralSansMedium">Note</strong>: Long URL must include the https://
                                    </Form.Text>
                                  </Form.Group>

                                  <div className="d-flex align-items-center gap-4 mb-3">
                                    <div className="d-flex align-items-center">
                                      {isSuperAdmin || initialUrlTracking ? (
                                        <div className="d-flex align-items-center">
                                          <Form.Check
                                            type="checkbox"
                                            checked={showForm}
                                            onChange={(e) => {
                                              setShowForm(e.target.checked);
                                              setFormData(prev => ({
                                                ...prev, 
                                                urlTracking: e.target.checked
                                              }));
                                            }}
                                            style={{ fontSize: "13px" }}
                                          />
                                          <img src={urlTrackingIcon} alt="urlTrackingIcon" className="mx-2" style={{ width: "12px", height: "12px" }} />
                                          <span style={{ fontSize: "13px" }}>URL Tracking</span>
                                        </div>
                                      ) : (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={<Tooltip>This feature is currently disabled. Please contact the system administrator.</Tooltip>}
                                        >
                                          <div className="d-flex align-items-center" style={{ cursor: "not-allowed" }}>
                                            <div className="position-relative">
                                              <Form.Check
                                                type="checkbox"
                                                checked={false}
                                                onChange={() => {}}
                                                disabled
                                                style={{ 
                                                  fontSize: "13px",
                                                  opacity: 0.5,
                                                  cursor: "not-allowed"
                                                }}
                                              />
                                              {/* <img 
                                                src={disable}
                                                alt="Disabled"
                                                className="position-absolute" 
                                                style={{
                                                  top: "50%",
                                                  left: "50%",
                                                  transform: "translate(-50%, -50%)",
                                                  width: "16px",
                                                  height: "16px"
                                                }}
                                              /> */}
                                            </div>
                                            <img src={urlTrackingIcon} alt="urlTrackingIcon" className="mx-2" style={{ width: "12px", height: "12px" }} />
                                            <span style={{ 
                                              fontSize: "13px",
                                              cursor: 'no-drop',
                                              textDecoration: 'line-through',
                                              opacity: '0.4'
                                            }}>URL Tracking</span>
                                          </div>
                                        </OverlayTrigger>
                                      )}
                                    </div>

                                    <div className="d-flex align-items-center">
                                      {isSuperAdmin || initialIndividualTracking ? (
                                        <div className="d-flex align-items-center">
                                          <Form.Check
                                            type="checkbox"
                                            checked={showIndividualForm}
                                            onChange={(e) => {
                                              setShowIndividualForm(e.target.checked);
                                              setFormData(prev => ({
                                                ...prev, 
                                                individualTracking: e.target.checked
                                              }));
                                            }}
                                            style={{ fontSize: "13px" }}
                                          />
                                          <img src={individualTrackingIcon} alt="individualTrackingIcon" className="mx-2" style={{ width: "12px", height: "12px" }} />
                                          <span style={{ fontSize: "13px" }}>Individual Tracking</span>
                                        </div>
                                      ) : (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={<Tooltip>This feature is currently disabled. Please contact the system administrator.</Tooltip>}
                                        >
                                          <div className="d-flex align-items-center" style={{ cursor: "not-allowed" }}>
                                            <div className="position-relative">
                                              <Form.Check
                                                type="checkbox"
                                                checked={false}
                                                onChange={() => {}}
                                                disabled
                                                style={{ 
                                                  fontSize: "13px",
                                                  opacity: 0.5,
                                                  cursor: "not-allowed"
                                                }}
                                              />
                                              {/* <img 
                                                src="@disable.png"
                                                alt="Disabled"
                                                className="position-absolute" 
                                                style={{
                                                  top: "50%",
                                                  left: "50%",
                                                  transform: "translate(-50%, -50%)",
                                                  width: "16px",
                                                  height: "16px"
                                                }}
                                              /> */}
                                            </div>
                                            <img src={individualTrackingIcon} alt="individualTrackingIcon" className="mx-2" style={{ width: "12px", height: "12px" }} />
                                            <span style={{ 
                                              fontSize: "13px",
                                              cursor: 'no-drop',
                                              textDecoration: 'line-through',
                                              opacity: '0.4'
                                            }}>Individual Tracking</span>
                                          </div>
                                        </OverlayTrigger>
                                      )}
                                    </div>
                                  </div>

                                  {(showForm || showIndividualForm) && (
                                    <Row className="mt-5">
                                      <Col md={6}>
                                        <Card className={`br-radius-12 ${!showForm ? 'opacity-50' : ''}`}>
                                          <Card.Body className="p-4">
                                            <div className="d-flex align-items-center mb-4">
                                              <img src={urlTrackingIcon} alt="urlTrackingIcon" className="me-2" style={{ width: "16px", height: "16px" }} />
                                              <h6 className="mb-0">URL Tracking Details</h6>
                                            </div>
                                            <Form.Group className="mb-3">
                                              <Form.Label className="fs-12">Campaign name</Form.Label>
                                              <Form.Control
                                                type="text"
                                                name="campaignName"
                                                value={formData.campaignName}
                                                onChange={handleInputChange}
                                                placeholder="Campaign Name"
                                                disabled={!showForm}
                                              />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                              <Form.Label className="fs-12">Locale</Form.Label>
                                              <Form.Select
                                                name="locale"
                                                value={formData.locale}
                                                onChange={handleInputChange}
                                                placeholder="Select Region"
                                                disabled={!showForm}
                                              >
                                                <option value="">Select Locale</option>
                                                {locales.map((locale) => (
                                                  <option key={locale.id} value={locale.locale}>
                                                    {locale.region}
                                                  </option>
                                                ))}
                                              </Form.Select>
                                            </Form.Group>

                                            <Form.Group>
                                              <Form.Label className="fs-12">Language</Form.Label>
                                              <Form.Select
                                                name="language"
                                                value={formData.language}
                                                onChange={handleInputChange}
                                                disabled={!showForm}
                                              >
                                                <option value="">Select Language</option>
                                                {[...new Set(locales.map(locale => locale.language))].map((language) => (
                                                  <option key={language} value={language.toUpperCase()}>
                                                    {language}
                                                  </option>
                                                ))}
                                              </Form.Select>
                                            </Form.Group>
                                          </Card.Body>
                                        </Card>
                                      </Col>

                                      <Col md={6}>
                                        <Card className={`br-radius-12 ${!showIndividualForm ? 'opacity-50' : ''}`}>
                                          <Card.Body className="p-4">
                                            <div className="d-flex align-items-center mb-4">
                                              <img src={individualTrackingIcon} alt="individualTrackingIcon" className="me-2" style={{ width: "16px", height: "16px" }} />
                                              <h6 className="mb-0">Individual Tracking Details</h6>
                                            </div>
                                            <Form.Group className="mb-3">
                                              <Form.Label className="fs-12">Individual ID</Form.Label>
                                              <Form.Control
                                                type="text"
                                                name="indivId"
                                                value={formData.indivId}
                                                onChange={handleInputChange}
                                                placeholder="Individual ID"
                                                disabled={!showIndividualForm}
                                              />
                                            </Form.Group>

                                            <Form.Group>
                                              <Form.Label className="fs-12">Mobile Number</Form.Label>
                                              <Form.Control
                                                type="text"
                                                name="mobileNo"
                                                value={formData.mobileNo}
                                                onChange={handleInputChange}
                                                placeholder="Mobile Number"
                                                disabled={!showIndividualForm}
                                              />
                                            </Form.Group>
                                          </Card.Body>
                                        </Card>
                                      </Col>
                                    </Row>
                                  )}

                                  <div className="d-flex justify-content-end">
                                    <Button variant="outline-secondary Generalsemi fw-600 me-3" onClick={handleCancel}>Cancel</Button>
                                    <Button 
                                      type="submit" 
                                      variant="success" 
                                      className="fw-600"
                                      disabled={isLoading}
                                    >
                                      {isLoading ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                          Processing...
                                        </>
                                      ) : (
                                        'Generate'
                                      )}
                                    </Button>
                                  </div>
                                </Form>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Tab>

                    <Tab eventKey="bulk" title="Bulk URL">
                      <BulkUpload isActive={activeTab === 'bulk'} />
                    </Tab>
                  </Tabs>
                )}

                <div className="mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Button 
                      style={{ fontFamily: "General Sans Medium" }} 
                      variant="outline-dark br-color-0C1116 fs-12 fw-500 text-242D35 pe-3 px-3 pt-1 pb-1 GeneralSansMedium d-flex align-items-center" 
                      onClick={toggleTable}
                    >
                      History {showTable ? <span className="arrow-icon"><LiaAngleUpSolid /></span> : <span className="arrow-icon"><LiaAngleDownSolid /></span>}
                    </Button>
                    
                    {/* {showTable && (
                      <div className="d-flex align-items-center justify-content-between gap-2 w-100">
                      </div>
                    )} */}
                  </div>
                </div>

                  {showTable && (
                  <Row className="mt-3">
                    <Col lg={12}>
                      <Card className="br-radius-12 border-0 shadow-none">
                        <Card.Header className="fw-600 bg-white br-radius-12 rounded-bottom-0 pt-0 pb-3 fs-20 br-color-EAECEE ps-0">
                          URL Shortening History
                        </Card.Header>

                        <Card.Body className="p-0 pt-3">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="d-flex align-items-center gap-2">
                              <div className="d-flex align-items-center" style={{ 
                                border: '1px solid #EAECEE', 
                                borderRadius: '8px', 
                              }}>
                                <DatePicker
                                  selected={startDate}
                                  onChange={(date) => handleDateChange(date, true)}
                                  className="form-control border-0 br-radius-32 me-2 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                  placeholderText="Start Date"
                                  maxDate={endDate || new Date()}
                                  dateFormat="MMM dd, yyyy"
                                  style={{ width: '180px' }}
                                />

                                <span className="mx-2">⇆</span>

                                <DatePicker
                                  selected={endDate}
                                  onChange={(date) => handleDateChange(date, false)}
                                  className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                  placeholderText="End Date"
                                  minDate={startDate}
                                  maxDate={new Date()}
                                  dateFormat="MMM dd, yyyy"
                                  style={{ width: '180px' }}
                                />

                                <InputGroup.Text 
                                  className="border-0 bg-transparent fs-12"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    setStartDate(null);
                                    setEndDate(null);
                                  }}
                                  title="Clear dates"
                                >
                                  {startDate || endDate ? (
                                    <FaCalendarAlt className="text-danger" />
                                  ) : (
                                    <FaCalendarAlt />
                                  )}
                                </InputGroup.Text>
                              </div>

                              <div className="position-relative" style={{ width: '200px' }}>
                                <Form.Control
                                  type="text"
                                  placeholder="Filter"
                                  value={searchTerm}
                                  onChange={(e) => debouncedSearch(e.target.value)}
                                  className="fs-12"
                                  disabled={isSearching}
                                />
                                {isSearching && (
                                  <div className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                    <span className="spinner-border spinner-border-sm text-secondary" role="status" />
                                  </div>
                                )}
                              </div>

                              {(searchTerm || startDate || endDate) && (
                                                <Button
                                  variant="light"
                                  className=""
                                  style={{ padding: "10px 10px" }}
                                                  onClick={() => {
                                    setSearchTerm('');
                                    setStartDate(null);
                                    setEndDate(null);
                                    handleSearch('');
                                  }}
                                  title="Clear Filter"
                                >
                                  <FcClearFilters className="fs-16" />
                                                </Button>
                              )}
                                              </div>

                                        <Button 
                              variant="success"
                                          size="sm"
                              onClick={handleDownloadReport}
                              className=""
                              style={{ borderRadius: "8px" }}
                                        >
                              Download CSV
                                        </Button>
                          </div>

                          <div className="mt-3">
                            
                            {isHistoryLoading ? (
                              <div className="text-center py-4">
                                <div className="spinner-border text-success" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 text-muted">Loading history...</p>
                              </div>
                            ) : filteredHistoryData.length === 0 ? (
                              <div className="text-center py-4">
                                <p className="text-muted">No records found</p>
                              </div>
                            ) : (
                              <>
                              <div className="table_responsive">
                                  <Table striped hover responsive>
                                <thead className="table-success custom-thead">
                                  <tr>
                                    <th>Created Date</th>
                                    <th>Campaign Name</th>
                                    <th>Sender ID</th>
                                    <th>Individual ID</th>
                                    <th>Long URL</th>
                                    <th>Short URL</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filteredHistoryData
                                    .slice(0, displaySize)
                                    .map((row, index) => (
                                      <tr key={index}>
                                        <td>
                                          {row.createdAt ? new Date(row.createdAt).toLocaleString('en-US', {
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true
                                          }) : '-'}
                                        </td>
                                        <td>{row.campaignName}</td>
                                        <td>{row.senderId}</td>
                                        <td>{row.indivId}</td>
                                        <td>
                                          <div className="border-dashedborder border-secondary border-dashed text-dark p-2 fs-10 border-dashed-url fw-normal d-flex justify-content-between align-items-center">
                                            <style>
  {`
    .two-line-ellipsis {
       width: 100px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.4em;
      max-height: 2.8em; /* 2 lines x line-height */
      word-break: break-word;
      white-space: normal;
    }
  `}
</style>
                                            <a 
                                              href={row.longUrl} 
                                              className="text-decoration-none text-313131 me-2 two-line-ellipsis" 
                                              target="_blank" 
                                              rel="noopener noreferrer"
                                              title={row.longUrl}
                                              style={{ flex: 1 }}
                                            >
                                              {row.longUrl.length > 80 
                                                ? `${row.longUrl.substring(0, 80)}...` 
                                                : row.longUrl}
                                            </a>
                                            <Button
                                              variant=""
                                              size="sm"
                                                  className="py-1 px-2 text-success"
                                              onClick={() => {
                                                navigator.clipboard.writeText(row.longUrl);
                                                toast.success('Long URL copied to clipboard!');
                                              }}
                                              title="Copy URL"
                                            >
                                              {/* <FaCopy size={14} /> */}
                                              <FontAwesomeIcon size={14} icon={faCopy} />
                                            </Button>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="border-dashedborder border-secondary border-dashed text-dark p-2 fs-10 border-dashed-url fw-normal d-flex justify-content-between align-items-center">
                                            <a 
                                              href={row.shortUrl} 
                                              className="text-decoration-none text-313131 me-2 two-line-ellipsis" 
                                              target="_blank" 
                                              rel="noopener noreferrer"
                                              title={row.shortUrl}
                                              style={{ flex: 1 }}
                                            >
                                              {row.shortUrl.length > 80 
                                                ? `${row.shortUrl.substring(0, 80)}...` 
                                                : row.shortUrl}
                                            </a>
                                            <Button
                                              variant=""
                                              size="sm"
                                              className="py-1 px-2 text-success"
                                              onClick={() => {
                                                navigator.clipboard.writeText(row.shortUrl);
                                                toast.success('Short URL copied to clipboard!');
                                              }}
                                              title="Copy URL"
                                            >
                                              <FontAwesomeIcon size={14} icon={faCopy} />
                                            </Button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </Table>
                          </div>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                  <div className="fs-12">
                                    Total Records: {totalElements}
                                  </div>
                                  <div className="d-flex justify-content-center">
                            <nav>
                                      <ul className="pagination mb-0">
                                <li className={`page-item ${currentDisplayPage === 0 ? "disabled" : ""}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => { setCurrentDisplayPage(0); setPage(0); }}
                                    disabled={currentDisplayPage === 0}
                                  >
                                    &laquo;
                                  </button>
                                </li>
                                <li className={`page-item ${currentDisplayPage === 0 ? "disabled" : ""}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => { const newPage = Math.max(currentDisplayPage - 1, 0); setCurrentDisplayPage(newPage); setPage(newPage); }}
                                    disabled={currentDisplayPage === 0}
                                  >
                                    &lt;
                                  </button>
                                </li>
                                {(() => {
                                  const totalDisplayPages = totalPages || 1;
                                  let startPage = Math.max(currentDisplayPage - 1, 0);
                                  let endPage = Math.min(startPage + 2, totalDisplayPages - 1);
                                  
                                  if (endPage === totalDisplayPages - 1) {
                                    startPage = Math.max(endPage - 2, 0);
                                  }

                                  return [...Array(endPage - startPage + 1)].map((_, idx) => (
                                    <li
                                      key={startPage + idx}
                                      className={`page-item ${currentDisplayPage === startPage + idx ? "active" : ""}`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() => { const newPage = startPage + idx; setCurrentDisplayPage(newPage); setPage(newPage); }}
                                      >
                                        {startPage + idx + 1}
                                      </button>
                                    </li>
                                  ));
                                })()}
                                <li className={`page-item ${currentDisplayPage === (totalPages - 1) ? "disabled" : ""}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => { const newPage = Math.min(currentDisplayPage + 1, (totalPages - 1)); setCurrentDisplayPage(newPage); setPage(newPage); }}
                                    disabled={currentDisplayPage === (totalPages - 1)}
                                  >
                                    &gt;
                                  </button>
                                </li>
                                <li className={`page-item ${currentDisplayPage === (totalPages - 1) ? "disabled" : ""}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => { const lastPage = (totalPages - 1); setCurrentDisplayPage(lastPage); setPage(lastPage); }}
                                    disabled={currentDisplayPage === (totalPages - 1)}
                                  >
                                    &raquo;
                                  </button>
                                </li>
                              </ul>
                            </nav>
                            </div>
                            <div className="d-flex gap-2">
                              <span className="mx-2 fs-12 d-flex align-items-center">
                                Page {Math.ceil(filteredHistoryData.length / displaySize)} of {totalPages}
                              </span>
                            </div>
                          </div>
                    </>
                  )}
                </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="border-0 bg-white">
          <Modal.Title><span className="fs-15 GeneralSansSemibold">Your Link is Ready!</span> <Image className="ms-2" width={28} src={Celebration} /></Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          <p className="fs-12 mb-2">Copy the link below to share it or choose a platform to share it to...</p>
          <div className="bg-f1f1f1 br-radius-12 p-3 pt-4 pb-4">
            <Form.Group className="mb-3">
              <div className="d-flex" style={{ border: '1px solid #EAECEE' }}>
                <Form.Control className="group-warning-btn GeneralSansSemibold rounded-0 fs-14 text-center border border-warning" type="text" value={shortUrl} readOnly />
                <Button variant="danger" onClick={handleCopy} style={{ fontFamily: "General Sans Medium", paddingLeft: '20px', paddingRight: '20px' }} className="bg-FF6347 GeneralSansSemibold fs-14 border border-warning rounded-0">
                  {copied ? "Copied!" : "Copy"}
                </Button>
              </div>
            </Form.Group>
            <Form.Text className="text-242D35 fs-12">
              <div className="d-flex">
                <strong className="GeneralSansMedium text-nowrap me-2">Long URL :</strong>
                <span className="long-url" title={formData.longUrl}>{formData.longUrl}</span>
              </div>
            </Form.Text>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 justify-content-start" style={{ paddingLeft: '20px' }}>
          <Button variant="success" onClick={handleClose}>
            Shorten another URL
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal 
        show={showDownloadPopup && totalElements > 100} 
        onHide={handleCloseDownloadModal}
        centered
        keyboard={false}
        backdrop="static"
      >
        <Modal.Header className="border-0">
          <Modal.Title>
            <span className="fs-15 GeneralSansSemibold">
              {isDownloading ? 'Downloading Report...' : 'Download Full Report'}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          {isDownloading ? (
            <div className="text-center">
              <div className="progress mb-3" style={{ height: '20px' }}>
                <div 
                  className="progress-bar bg-success progress-bar-striped progress-bar-animated" 
                  role="progressbar" 
                  style={{ width: `${downloadProgress}%` }} 
                  aria-valuenow={downloadProgress} 
                  aria-valuemin="0" 
                  aria-valuemax="100"
                >
                  <span className="fw-bold">{`${downloadProgress}%`}</span>
                </div>
              </div>
              <p className="fs-12 mb-2">
                {downloadProgress === 100 
                  ? 'Finalizing your download...' 
                  : 'Please wait while we prepare your report...'}
              </p>
            </div>
          ) : (
            <>
              <p className="fs-12 mb-2">
                There are {totalElements} records available. To view all records, please download the complete report as a CSV file.
              </p>
              <div className="d-flex align-items-center mt-3">
                <MdOutlineDownloadForOffline className="text-success me-2" size={20} />
                <span className="fs-12">Download includes all {totalElements} records</span>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          {!isDownloading ? (
            <Button 
              variant="success" 
              className="GeneralSansSemibold w-100"
              onClick={handleDownloadReport}
            >
              Download Complete Report
            </Button>
          ) : (
            <Button 
              variant="outline-secondary" 
              onClick={handleCloseDownloadModal}
              className="GeneralSansSemibold"
            >
              Cancel Download
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCancelConfirm}
        onHide={() => setShowCancelConfirm(false)}
        centered
        size="sm"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>
            <span className="fs-15 GeneralSansSemibold">Cancel Download?</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-12 mb-2">
            Are you sure you want to cancel the download? Progress will be lost.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            onClick={() => setShowCancelConfirm(false)}
            className="GeneralSansSemibold"
          >
            Continue Download
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setShowCancelConfirm(false);
              setShowDownloadPopup(false);
              setIsDownloading(false);
              setDownloadProgress(0);
            }}
            className="GeneralSansSemibold"
          >
            Cancel Download
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default SingleUrl;